import styled from 'styled-components';

export const AuthCopyAckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default {};
